module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('PanelHeading', {
    attrs: {
      "title": "Lecture Notes",
      "subtitle": "Lecture Notes can be converted to Micro Notes for studying"
    }
  }), _vm._v(" "), _vm._c('PanelBody', [_vm._c('code', [_vm._v("#todo list them with links to editor to edit content")]), _vm._v(" "), _vm._c('h3', [_vm._v("Lecture notes")]), _vm._v("\n            " + _vm._s(_vm.lectureNotes) + "\n\n          ")])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74189120!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecture-note-list/LectureNoteList.vue
// module id = 684
// module chunks = 1